// extracted by mini-css-extract-plugin
export var customsize = "kontakty-module--customsize--E341O";
export var lastrow = "kontakty-module--lastrow--mCGB1";
export var prtp = "kontakty-module--prtp--UugrQ";
export var prwhatsapp = "kontakty-module--prwhatsapp--Im5Cn";
export var subheader = "kontakty-module--subheader--iSMhH";
export var subitem = "kontakty-module--subitem--3aeJT";